import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import uniqid from 'uniqid'

import { OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE } from 'Constants'

import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'

import { workflowDetails } from 'Pages/Workflow/recoil/state/data'

const useGetWorkflowSidebar = () => {
  const intl = useIntl()
  const { FromSms, Type } = useRecoilValue(workflowDetails)

  if (Type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE) {
    return [
      {
        id: uniqid(),
        label: intl.formatMessage({
          id: 'Load.AutomationWorkflow.DragElementMessage'
        }),
        isDragDisabled: true,
        IdMessage: 0,
        MessageType: WORKFLOW_MESSAGE_TYPE_EMAIL,
        Value: 1,
        ValueType: 0,
        WaitType: 0,
        StepType: 'SendEmail'
      },
      {
        id: uniqid(),
        label: intl.formatMessage({
          id: 'Load.AutomationWorkflow.DragElementWaitTypeWait'
        }),
        isDragDisabled: true,
        IdMessage: -1,
        MessageType: 0,
        Value: '1',
        ValueType: 0,
        WaitType: -1,
        itemError: 'initialError',
        StepType: 'Wait'
      },
      {
        id: uniqid(),
        label: intl.formatMessage({
          id: 'Load.AutomationWorkflow.DragElementChangeSubscriptionStatus'
        }),
        isDragDisabled: true,
        IdMessage: -1,
        MessageType: -1,
        StepType: 'ChangeStatus'
      }
    ]
  }

  return [
    {
      id: uniqid(),
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.DragElementMessage'
      }),
      IdMessage: 0,
      MessageType: WORKFLOW_MESSAGE_TYPE_EMAIL,
      Value: 1,
      ValueType: 0,
      WaitType: 0,
      StepType: 'SendEmail'
    },
    {
      id: uniqid(),
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.DragElementMessageSms'
      }),
      tip:
        FromSms === ''
          ? intl.formatMessage({
              id: 'Load.AutomationWorkflow.SmsNotDraggable'
            })
          : undefined,
      isDragDisabled: FromSms === '',
      IdMessage: 0,
      MessageType: WORKFLOW_MESSAGE_TYPE_SMS,
      Value: 1,
      ValueType: 0,
      WaitType: 0,
      StepType: 'SendSms'
    },
    {
      id: uniqid(),
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.DragElementWaitTypeWait'
      }),
      IdMessage: -1,
      MessageType: 0,
      Value: '1',
      ValueType: 0,
      WaitType: -1,
      itemError: 'initialError',
      StepType: 'Wait'
    }
  ]
}

export default useGetWorkflowSidebar
